import React, { createContext, useContext } from "react";

const GoogleAuthContext = createContext();

export const GoogleAuthProvider = ({ children }) => {
  return (
    <GoogleAuthContext.Provider value={{ 
      isSignedIn: !!localStorage.getItem('credential'), 
    }}>
      {children}
    </GoogleAuthContext.Provider>
  )
}

export const useGoogleAuth = () => useContext(GoogleAuthContext);
